export default __webpack_public_path__ + "static/media/SearchIconWhite.2c9cb26c.svg";